module.exports = __webpack_public_path__ + "img/box2_bg.77bd3bf9.png";